/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_DiscussInputs */

const en_homepage_listen_in_discuss = /** @type {(inputs: Homepage_Listen_In_DiscussInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare For Discuss`)
};

const es_homepage_listen_in_discuss = /** @type {(inputs: Homepage_Listen_In_DiscussInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando una discusión`)
};

/**
* | output |
* | --- |
* | "Prepare For Discuss" |
*
* @param {Homepage_Listen_In_DiscussInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_discuss = /** @type {((inputs?: Homepage_Listen_In_DiscussInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_DiscussInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_discuss(inputs)
	return en_homepage_listen_in_discuss(inputs)
});